import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Heritage from "@/components/Heritage";
import Schedule from "@/components/Schedule";
import FeedSection from "@/components/FeedSection";
import Gallery from "@/components/Gallery";
import Committee from "@/components/Committee";
import Donate from "@/components/Donate";
import ContactSection from "@/components/ContactSection";
import SponsorsStrip from "@/components/SponsorsStrip";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="grain relative">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Heritage />
        <Schedule />
        <FeedSection />
        <Gallery />
        <Committee />
        <Donate />
        <ContactSection />
        <SponsorsStrip />
      </main>
      <Footer />
    </div>
  );
}
